import { Link } from 'react-router-dom';
import { Box, Typography, Tabs, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { c } from '../../theme/colorUtils';


export const Root = styled(Box)(() => ({
  display:'block',
  width:'100%',
  '& .wordcloud':{
    maxWidth:'500px',
    width:'100%',
    margin:'0 auto',
  },
  '.subTxt':{
    fontSize:'0.875rem',
    color:`${c.text02}!important`
  },
}));

export const LinkButton = styled(Link)(() => ({
  display:'inline-flex',
  alignItems:'center',
  justifyContent:'space-between',
  textDecoration: 'none',
  boxSizing: "border-box",
  color: c.text01,
}));

export const CardBox = styled(Box)(() => ({
  backgroundColor: c.bg,
  border: `1px solid ${c.grayLight}`,
  borderRadius: 20,
  padding: "32px 16px",
  margin: "16px 0",
}));

export const SolidBox = styled(Box)(() => ({
  backgroundColor: c.bg,
  borderRadius: 16,
  padding: "24px 16px",
  margin: "8px 0",
}));

export const TitleStyle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "1.25rem",
    fontWeight: 600,
    color: c.text01,
    padding:"24px 16px",
    display:'flex',
    flexDirection:'row',
    gap:'8px',
    alignItems:'center'
  },
}));

export const CustomTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    backgroundColor: `${c.text01}!important`, 
  },
  '& .MuiTab-root': {
    color: `${c.hard}!important`, 
  },
  '& .Mui-selected': {
    color: `${c.text01}!important`,
  },
});

export const ListTitle = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "1rem",
    fontWeight: 700,
    color: c.text01,
    "& span": {
      fontSize: "0.875rem",
      fontWeight: 400,
    },
  },
}));

export const ListCaption = styled(Typography)(() => ({
  "&.MuiTypography-root": {
    fontSize: "0.75rem",
    fontWeight: 400,
    color: c.text02,
  },
}));

export const Loader = styled('span')(() => ({
  position:'relative',
  width : 48,
  height: 48,
  borderRadius: '50%',
  display: 'inline-block',
  border: `5px solid ${c.grayLight}`,
  boxSizing:'border-box',
  '& .spinner':{
    position: 'absolute',
    top: -5,
    left: -5,
    width: 48,
    height: 48,
  },
  '& .path': {
    position:'absolute',
    top:0,
    left:0,
    stroke: c.primary,
    strokeLinecap: 'round',
    animation: `dash 1s ease-in-out infinite`,
  },
  '@keyframes rotate': {
    '0%': { transform: 'rotate(0deg)' },
    '100%' :{transform: 'rotate(360deg)'},
  },
  '@keyframes dash':{
    '0%': {
      strokeDasharray: '1, 150',
      strokeDashoffset: '0',
    },
    '50%': {
      strokeDasharray: '90, 150',
      strokeDashoffset: -35,
    },
    '100%': {
      strokeDasharray: '90, 150',
      strokeDashoffset: -124,
    }
  }
}));

